import Form, {
  formCreate,
} from '@/found/components/form';
import request from '@/found/utils/request';
import {
  min,
} from 'mathjs';
import _ from 'xe-utils';

import budgetSubject from './components/budgetSubject.vue';
// import OrgList1 from './components/org-list1.vue';
// import FeeSuject from './components/fee-suject.vue';

formCreate.component('BudgetSubject', budgetSubject);
// formCreate.component('OrgList1', OrgList1);
// formCreate.component('FeeSuject', FeeSuject);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      rule: [],
      formFunctionCode: 'main_form',
      costRulesTierList: [],
      buttons: {
        submit: this.formConfig.type !== 'view',
      },
    };
  },

  methods: {
    // 设置规则
    setRule(item) {
      const v = item;
      if (v.field === 'calculateCategory') {
        v.props = {
          ...v.props,
        };
        v.on = {
          ...v.on,
          change: (e) => {
            if (e === 'Y') {
              this.hiddenFields(false, ['categoryCodeList']);
            } else {
              this.hiddenFields(true, ['categoryCodeList']);
              this.setValue({
                categoryCode: '',
                categoryName: '',
                categoryNameList: [],
                categoryCodeList: [],
              });
            }
          },
        };
      }
      if (v.field === 'hardControl') {
        v.props = {
          ...v.props,
        };
        v.on = {
          ...v.on,
          change: (e) => {
            if (e === 'Y') {
              this.hiddenFields(false, ['highestRate']);
            } else {
              this.hiddenFields(true, ['highestRate']);
              this.setValue({
                highestRate: '',
              });
            }
          },
        };
      }

      if (v.field === 'categoryCodeList') {
        v.restful = '/tpm/tpmCostTypeCategoriesController/list';
        v.optionsKey = {
          label: 'categoriesName',
          value: 'categoriesCode',
        };
        v.params = {
          enableStatus: '009',
        };
        v.props = {
          ...v.props,
        };
        v.on = {
          ...v.on,
          change: (e) => {
            const categoryName = e.map((code) => v.options.find((t) => t[v.optionsKey.value]
              === code)?.[v.optionsKey.label] || '').join(',');
            const categoryNameList = categoryName.split(',');
            this.setValue({
              categoryCode: e.join(','),
              categoryName,
              categoryNameList,
            });
          },
        };
      }
      if (v.field === 'highestRate') {
        v.props = {
          ...v.props,
          min: 0,
        };
      }
      return item;
    },

    // 完成渲染
    formComplete() {
      const {
        code,
      } = this.formConfig;
      this.hiddenFields(true, ['categoryCodeList', 'highestRate']);

      if (code !== 'add') {
        request.get('/tpm/tpmIndicatorController/query', {
          id: this.formConfig.row.id,
        }).then((res) => {
          if (res.success) {
            const {
              result,
            } = res;
            if (result.calculateCategory === 'Y') {
              this.hiddenFields(false, ['categoryCodeList']);
            }
            if (result.hardControl === 'Y') {
              this.hiddenFields(false, ['highestRate']);
            }
            if (result.categoryCode) {
              result.categoryCodeList = result.categoryCode.split(',');
            }
            if (result.categoryName) {
              result.categoryNameList = result.categoryName.split(',');
            }
            if (result.feeType) {
              result.feeTypeList = result.feeType.split(',');
            }
            let budgetSubjects = [];
            const {
              budgetSubjectsNameList,
              budgetSubjectsCodeList,
            } = result;
            if (budgetSubjectsNameList && budgetSubjectsCodeList) {
              budgetSubjects = budgetSubjectsNameList.split(',').map((item, index) => ({
                budgetSubjectsName: item,
                budgetSubjectsCode: budgetSubjectsCodeList.split(',')[index],
              }));
            }
            this.setValue({
              ...result,
              budgetSubjects,
            });
          }
        });
      }

      const feeTypeList = this.getRule('feeTypeList');
      const budgetSubjects = this.getRule('budgetSubjects');
      budgetSubjects.props = {
        ...budgetSubjects.props,
        params: {
          functionCode: 'budget-subject-list',
          paramData: {
            enableStatus: '009',
          },
        },
        getValue: (field) => this.getFieldValue(field),
        title: budgetSubjects.title,
        autosize: {
          minRows: 1,
          maxRows: 6,
        },
        formConfig: this.formConfig,
      };
      budgetSubjects.on = {
        ...budgetSubjects.on,
        change: (e) => {
          const subjectData = [];
          e.forEach((m) => {
            const obj = m;
            subjectData.push({
              budgetSubjectsName: obj.budgetSubjectsName,
              budgetSubjectsCode: obj.budgetSubjectsCode,
            });
          });
          this.setValue({
            budgetSubjects: subjectData || [],
            budgetSubjectsCodeList: (subjectData.map((t) => t.budgetSubjectsCode) || [])
              .join(','),
            budgetSubjectsNameList: (subjectData.map((t) => t.budgetSubjectsName) || [])
              .join(','),
          });
        },
      };
      feeTypeList.on = {
        ...feeTypeList.on,
        change: (e) => {
          this.setValue({
            feeType: e.join(','),
            budgetSubjects: [],
            budgetSubjectsCodeList: '',
            budgetSubjectsNameList: '',
          });
          budgetSubjects.props = {
            ...budgetSubjects.props,
            params: {
              ...budgetSubjects.props.params,
              paramData: {
                ...budgetSubjects.props.params.paramData,
                feeType: e.join(','),
              },
            },
          };
        },
      };
    },
    // 提交
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        const params = {
          ...formData,
        };
        if (params.hardControl === 'Y' && params.highestRate === 0) {
          this.$message.error('最大比例不能为0！');
          return false;
        }
        // 默认新增
        let url = '/tpm/tpmIndicatorController/save';
        // // 有id  就是编辑
        if (this.formConfig.row && this.formConfig.row.id) {
          url = '/tpm/tpmIndicatorController/update';
          params.id = this.formConfig.row.id;
        }
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
